module.exports = __webpack_public_path__ + "static/img/produce05.b904e99.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/produce05.png
// module id = 135
// module chunks = 4